import dataStore from "@/services/api/store";

class Paginator {
  constructor(store, queryParams, limit = 15) {
    this.queryParams = queryParams;
    this.limit = limit;
    this.offset = 0;
    this.finished = false;
    this.store = store;
  }
  next() {
    let queryParams = Object.assign({ limit: this.limit }, this.queryParams, {
      offset: this.limit * this.offset
    });
    if (!this.finished) {
      return dataStore
        .findAll(this.store, queryParams, { force: true })
        .then(results => {
          let realResults;

          if (results.results !== undefined) {
            if (!results.next) {
              this.finished = true;
            } else {
              this.offset += 1;
            }
            realResults = results.results;
          } else {
            realResults = results;
            if (results.length === this.limit) {
              this.offset += 1;
            } else {
              this.finished = true;
            }
          }
          return realResults;
        });
    }
  }
}

export default Paginator;
